/// <reference types="./error.d.mts" />
import * as $fetch from "../../gleam_fetch/gleam/fetch.mjs";
import * as $response from "../../gleam_http/gleam/http/response.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { Ok, Error, CustomType as $CustomType } from "../gleam.mjs";

export class FetchError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class HttpError extends $CustomType {
  constructor(code, reason) {
    super();
    this.code = code;
    this.reason = reason;
  }
}

export class DecodeError extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class NilError extends $CustomType {
  constructor(message) {
    super();
    this.message = message;
  }
}

export function internal_error(response, reason) {
  let $ = response.status;
  if ($ === 500) {
    return new Error(new HttpError(500, reason));
  } else {
    return new Ok(response);
  }
}
